import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppV2 from './AppV2';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId="114195144220-3dm8ihm1j0gggpelo7ieuhr38ah1bpa4.apps.googleusercontent.com"> */}
    <GoogleOAuthProvider clientId="114195144220-1if3nler3aslvfjhpudhi09okfq6jrfv.apps.googleusercontent.com">
      <AppV2 />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
